// Nederlandse labels en badgekleuren voor de Leiderschap-enums. Zelfde
// {value, label, className}-patroon als CATEGORIES/STATUSES in
// ContractManagementPage.jsx, zodat de stijl consistent blijft.
import type {
  ActionItemPriority,
  ActionItemStatus,
  DecisionStatus,
  MeetingStatus,
  MeetingType,
  MinutesStatus,
} from './types';

interface Labeled<T extends string> {
  value: T;
  label: string;
  className: string;
}

export const MEETING_TYPES: Labeled<MeetingType>[] = [
  { value: 'bestuur', label: 'Bestuur', className: 'bg-slate-100 text-slate-700' },
  { value: 'oudstenoverleg', label: 'Oudstenoverleg', className: 'bg-slate-100 text-slate-700' },
  { value: 'staf', label: 'Staf', className: 'bg-slate-100 text-slate-700' },
  { value: 'ad_hoc', label: 'Ad-hoc', className: 'bg-slate-100 text-slate-700' },
];

export const MEETING_STATUSES: Labeled<MeetingStatus>[] = [
  { value: 'gepland', label: 'Gepland', className: 'bg-teal-100 text-teal-700' },
  { value: 'gehouden', label: 'Gehouden', className: 'bg-emerald-100 text-emerald-700' },
  { value: 'geannuleerd', label: 'Geannuleerd', className: 'bg-slate-100 text-slate-500' },
];

export const MINUTES_STATUSES: Labeled<MinutesStatus>[] = [
  { value: 'concept', label: 'Concept', className: 'bg-amber-100 text-amber-700' },
  { value: 'vastgesteld', label: 'Vastgesteld', className: 'bg-emerald-100 text-emerald-700' },
];

export const DECISION_STATUSES: Labeled<DecisionStatus>[] = [
  { value: 'open', label: 'Open', className: 'bg-slate-100 text-slate-700' },
  { value: 'aangenomen', label: 'Aangenomen', className: 'bg-emerald-100 text-emerald-700' },
  { value: 'verworpen', label: 'Verworpen', className: 'bg-red-100 text-red-700' },
  { value: 'uitgesteld', label: 'Uitgesteld', className: 'bg-amber-100 text-amber-700' },
];

export const ACTION_ITEM_STATUSES: Labeled<ActionItemStatus>[] = [
  { value: 'open', label: 'Open', className: 'bg-slate-100 text-slate-700' },
  { value: 'in_uitvoering', label: 'In uitvoering', className: 'bg-teal-100 text-teal-700' },
  { value: 'voltooid', label: 'Voltooid', className: 'bg-emerald-100 text-emerald-700' },
  { value: 'vervallen', label: 'Vervallen', className: 'bg-slate-100 text-slate-500' },
];

export const ACTION_ITEM_PRIORITIES: Labeled<ActionItemPriority>[] = [
  { value: 'laag', label: 'Laag', className: 'bg-slate-100 text-slate-600' },
  { value: 'normaal', label: 'Normaal', className: 'bg-teal-100 text-teal-700' },
  { value: 'hoog', label: 'Hoog', className: 'bg-red-100 text-red-700' },
];

export function findLabel<T extends string>(options: Labeled<T>[], value: T | null | undefined): string {
  return options.find((option) => option.value === value)?.label ?? (value || '-');
}

export function findClassName<T extends string>(options: Labeled<T>[], value: T | null | undefined): string {
  return options.find((option) => option.value === value)?.className ?? 'bg-slate-100 text-slate-700';
}
